import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {Box} from '@mui/material';
import {reverse} from 'named-urls';
import React from 'react';
import OrderStatus from '../../../../components/OrderStatus';
import routes from '../../../../routes';

const Wrapper = ({title, order, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}>
        {order ? (
          <Box display="flex" flex={1} justifyContent="flex-end"><OrderStatus order={order}/></Box>
        ) : null}
      </Title>
      <Notice
        display={order && order.archived}
        message={[
          'This sales order has been archived and is therefore no longer available.',
          order?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['salesOrder']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Sales Orders', link: routes.salesOrders.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: routes.archive.index},
  {title: 'Sales Orders', link: reverse(routes.archive.index, {tab: 'sales-orders'})}
];

export default Wrapper;
